export const SERVICE_TITAN_SHOW_OPTIONS = {
  SHOW_CLIENT_AND_SECRET: "showClientAndSecret",
  MODAL_SHOW_CLIENT_AND_SECRET: "modalShowClientAndSecret",
} as const;
